/* eslint-disable import/default */

import './include-babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/RootSearch';
const store = configureStore();

const el = document.getElementById('appSearch'),
  searchTerms = el.hasAttribute('data-search-terms') ? el.getAttribute('data-search-terms') : undefined,
  catId = el.hasAttribute('data-cat-id') ? parseInt(el.getAttribute('data-cat-id')) : undefined,
  subCatId = el.hasAttribute('data-sub-cat-id') ? parseInt(el.getAttribute('data-sub-cat-id')) : undefined,
  brandId = el.hasAttribute('data-brand-id') ? parseInt(el.getAttribute('data-brand-id')) : undefined,
  titleOverride = el.hasAttribute('data-title-override') ? el.getAttribute('data-title-override') : '',
  filter = el.hasAttribute('data-filter') ? el.getAttribute('data-filter') : '',
  isSearch = el.hasAttribute('data-is-search'),
  isNonOemFirst = !el.hasAttribute('data-landing');

render(
  <AppContainer>
    <Root store={store}
          history={history}
          searchTerms={searchTerms}
          catId={catId}
          subCatId={subCatId}
          brandId={brandId}
          titleOverride={titleOverride}
          filter={filter}
          isNonOemFirst={isNonOemFirst}
          isSearch={isSearch}
    />
  </AppContainer>,
  document.getElementById('appSearch')
);

if (module.hot) {
  module.hot.accept('./components/RootSearch', () => {
    const NewRoot = require('./components/RootSearch').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('appSearch')
    );
  });
}
